// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardComponentLink_container__Xw3Xb"};